module.exports = __webpack_public_path__ + "media/images/products/products/modal/3-c2ac46c4cd860bd956390bb705a216f0.jpg";